// extracted by mini-css-extract-plugin
export default {"tableTabs":"tableTabs-LKX_7N35"};